import envConfig from '../../static/config';
import AppStore from '../stores/AppStore';
import SessionStore from '../stores/SessionStore';
import InternetBankingActions from '../actions/InternetBankingActions';
import StringConstants from '../constants/StringConstants';
import UserManagementStore from '../stores/UserManagementStore';
import { getCookieContent } from '../utils/BiocatchUtils';
import URLUtils from './UrlUtils';

export const getDebitCardUrl = (
  navigationUrl,
  {
    account_id = '',
    account_number = '',
    sort_code = '',
    account_name = '',
    display_name = '',
  }
) => {
  if (!SessionStore.getAll().authenticated) {
    InternetBankingActions.navigateToWebTask(
      StringConstants.WEB_INVALIDTOKENSESSIONTIMEOUT
    );
    SessionStore.setIsNavigatingToWebAppDuringValidSession(false);
    return;
  }
  const accessToken =
    SessionStore.getURLTokenValue() || SessionStore.getToken()['access_token'];
  const bankID = SessionStore.getSessionBankID();
  const navigateURL = navigationUrl
    .replace('{user_tracking_id}', AppStore.getUserTrackingID())
    .replace('{access_token}', accessToken)
    .replace('{state}', envConfig.device_name)
    .replace('{bank_id}', bankID)
    .replace('{brandId}', envConfig.brandId)
    .replace('{account_id}', account_id)
    .replace('{account_name}', encodeURIComponent(account_name))
    .replace('{account_number}', account_number)
    .replace('{sort_code}', sort_code)
    .replace('{display_name}', encodeURIComponent(display_name))
    .replace(
      '{redirect_uri}',
      encodeURIComponent(
        envConfig.redirectToBOW
          .replace('{access_token}', accessToken)
          .replace('{user_tracking_id}', AppStore.getUserTrackingID())
      )
    );
  SessionStore.setTokenDelete(false);
  SessionStore.setIsNavigatingToWebAppDuringValidSession(true);
  const bcsid = getCookieContent('bcsid');
  return navigateURL.concat(`&bcsid=${bcsid}`);
};

class NavigateToWebApps {
  static resolveRedirectUri(accessToken) {
    return envConfig.redirectToBOW
      .replace('{access_token}', accessToken)
      .replace('{user_tracking_id}', AppStore.getUserTrackingID());
  }

  static resolveRedirectHelpUri(accessToken) {
    return envConfig.redirectToHelp
      .replace('{access_token}', accessToken)
      .replace('{user_tracking_id}', AppStore.getUserTrackingID());
  }

  static navigateTo(navigatingTo) {
    if (!SessionStore.getAll().authenticated) {
      InternetBankingActions.navigateToWebTask(
        StringConstants.WEB_INVALIDTOKENSESSIONTIMEOUT
      );
      SessionStore.setIsNavigatingToWebAppDuringValidSession(false);
      return;
    }
    const accessToken =
      SessionStore.getURLTokenValue() ||
      SessionStore.getToken()['access_token'];
    const bankID = SessionStore.getSessionBankID();
    const navigateURL = navigatingTo
      .replace('{user_tracking_id}', AppStore.getUserTrackingID())
      .replace('{access_token}', accessToken)
      .replace('{state}', envConfig.device_name)
      .replace('{bank_id}', bankID)
      .replace('{brandId}', envConfig.brandId)
      .replace(
        '{redirect_uri}',
        encodeURIComponent(this.resolveRedirectUri(accessToken))
      )
      // dept fix this once the paas urls are in use
      .replace(
        '{details}',
        UserManagementStore.isBusinessUser()
          ? 'business-details'
          : 'customer-details'
      )
      .replace(
        '{context_name}',
        UserManagementStore.isSMEUser() ? 'sme' : 'retail'
      );
    SessionStore.setTokenDelete(false); // Not to delete token while navigating to other webapps
    SessionStore.setIsNavigatingToWebAppDuringValidSession(true);
    const bcsid = getCookieContent('bcsid');
    window.location.href = navigateURL.concat(`&bcsid=${bcsid}`);
  }

  static navigateToLoginPage() {
    SessionStore.setIsNavigatingToWebAppDuringValidSession(false);
    window.location.href = URLUtils.formatLoginAndRegUrl(
      envConfig.loginAndRegistrationUrl,
      localStorage.getItem('uniqueId'),
      UserManagementStore.isSMEUser()
    );
  }

  static navigateToBrochurewarePage(bankWebsite, targetBlank = false) {
    if (targetBlank) {
      window.open(bankWebsite, '_blank');
    } else {
      SessionStore.setIsNavigatingToWebAppDuringValidSession(false);
      window.location.href = bankWebsite;
    }
  }

  static navigateToDebitCardWebAppPage(navigationUrl, accountDetails) {
    window.location.href = getDebitCardUrl(navigationUrl, accountDetails);
  }
  static navigateToVulnerableCustomersWebAppPage(fromHelpPage) {
    if (!SessionStore.getAll().authenticated) {
      InternetBankingActions.navigateToWebTask(
        StringConstants.WEB_INVALIDTOKENSESSIONTIMEOUT
      );
      SessionStore.setIsNavigatingToWebAppDuringValidSession(false);
      return;
    }
    const accessToken =
      SessionStore.getURLTokenValue() ||
      SessionStore.getToken()['access_token'];
    const bankID = SessionStore.getSessionBankID();
    const navigateURL = envConfig.vulnerableCustomersWebAppLink
      .replace('{access_token}', accessToken)
      .replace('{user_tracking_id}', AppStore.getUserTrackingID())
      .replace('{state}', envConfig.device_name)
      .replace('{bank_id}', bankID)
      .replace(
        '{redirect_uri}',
        encodeURIComponent(
          fromHelpPage === 'HELP'
            ? this.resolveRedirectHelpUri(accessToken)
            : this.resolveRedirectUri(accessToken)
        )
      )
      .replace('{refer}', fromHelpPage ? 'HELP' : 'null');
    SessionStore.setTokenDelete(false);
    SessionStore.setIsNavigatingToWebAppDuringValidSession(true);
    window.location.href = navigateURL;
  }
  static navigateToBrochurewareYourSupportPage() {
    window.open(envConfig.brochurewareYourSupportLink);
  }
}

export default NavigateToWebApps;
